
import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { BrandVO } from './vo/brand.vo';

@Component
export default class Brands extends Vue {

  brands: Array<BrandVO> = [];
  swiperTop = {
    slidesPerView: 13,
    preloadImages: false,
    lazy: true,
    freeMode: true
  };

  currentInitial = '';

  //////////////////////////////
  // computed
  //////////////////////////////

  get brandInitials(): Array<string> {
    return Array.from(new Set(this.brands.map((b) => (b.brandEngNm || '#').toUpperCase().charAt(0)))).sort();
  }

  //////////////////////////////
  // methods
  //////////////////////////////

  getBrandsByInitial(initial: string){
    return this.brands.filter((b)=>{return (b.brandEngNm || '#').toUpperCase().startsWith(initial)});
  }

  getVScrollToOptions(el) {
    return {
      el: el,
      offset: -65, 
    }
  }

  //////////////////////////////
  // initialized events
  //////////////////////////////
  beforeCreate(): void {
    axios.get('/brands')
    .then((r) => {
      this.brands = r.data as Array<BrandVO>;
    });
  }
}

